<!-- ══════════════════════════════════════════════════════════════════════════
     COMERCIOS — el listado.

     🔴 REDISEÑO 2026-09-20, aprobado por Juan: *«cuando tú te metes a ver los
     comercios, da urticaria»*, *«demasiada caja, demasiado contenido, la vista
     se pierde»*.

     Lo que decide quien abre esta pantalla: A CUÁL COMERCIO HAY QUE ATENDER —
     el que todavía no puede vender, el que no tiene comisión, el que no tiene
     cuenta. Todo lo demás baja o se va.

     Lo que salió, y por qué (medido antes de tocar nada):
       · CINCO tarjetas de métrica en DOS filas más la barra de filtros: ~600 px
         antes de la primera fila de la tabla. Entraban dos o tres comercios.
         — «Comercios» (el total ya está en el conteo de la barra y en el pie).
         — «Tiendas de la red» (en esta pantalla no se decide nada con ese
           total: es un dato de Organización).
         — «Sin comisión» y «Sin cuenta» repetían, cuarenta líneas más abajo,
           los dos chips que además SÍ filtran. Quedaron los chips.
         — «Sin habilitar» era la métrica más valiosa y no se podía tocar: pasó
           a ser la cinta de arriba, con el enlace que los deja a la vista.
       · la tarjeta que envolvía la tabla — la tabla va a la vista.
       · el subtítulo «Listado de comercios / La fila entera abre el detalle…»:
         el título repetía el de la página y el renglón explicaba un gesto que
         ya se descubre al pasar el mouse.
       · el renglón de glosario bajo el título, reemplazado por el reparto de
         estados, que es un dato y no una definición.

     Rótulos que cambiaron:
       · «Ficha»  → «Aprobación»    — «Ficha» nombra el artefacto; la columna
                                      contesta «¿está aprobado?».
       · «Base»   → «Base de cálculo» — el término completo ya existe en la casa.
       · «Limpiar» → «Limpiar filtros» — un botón dice qué hace, con su objeto.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="kb-page kb-gateway">

  <!-- ══ Encabezado ═══════════════════════════════════════════════════════════ -->
  <!-- ══════════════════════════════════════════════════════════════════════════
       🔴 LA CABECERA, COPIADA DE HZ NOTIFICACIONES — orden de Juan, 2026-09-20:
       *«mira al 100% cómo está hecho el front de HZ notificaciones… eso es
       shadcn, así quiero mis vistas»*.

       Tres cosas que esa pantalla hace y ésta no hacía:
         · el título lleva su ICONO, del mismo tamaño que la letra;
         · el renglón de abajo NO enumera estados: dice el total, cuántos están
           bien, y —destacado— CUÁNTOS HAY QUE ATENDER. Ese último es la razón
           por la que alguien abre esta pantalla, así que es lo único en color;
         · dos botones y no uno: recargar es una ACCIÓN y dar de alta es otra, y
           el ojo tiene que distinguir la que crea de la que refresca.
       ══════════════════════════════════════════════════════════════════════════ -->
  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title flex items-center gap-2 !font-bold">
        <i class="fas fa-store text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Comercios
      </h1>
      <!-- 2026-09-24: el renglón ya no cuenta —los números viven en las tarjetas
           de abajo y un número no se repite en la misma pantalla—; dice qué se
           ve, como el renglón de cada pantalla del Gateway. -->
      <p class="kb-page-meta">Los comercios de la red y si hoy pueden vender.</p>
    </div>
    <div class="flex items-center gap-2">
      <!-- Botón de icono, como el refrescar del Gateway; el rótulo sigue en
           `title` y `aria-label`. -->
      <button type="button" class="kb-btn kb-btn-outline kb-btn-icon h-9 w-9" (click)="cargar()"
              [disabled]="loading" title="Volver a consultar" aria-label="Volver a consultar">
        <i class="fas fa-sync-alt !text-foreground" [class.fa-spin]="loading" aria-hidden="true"></i>
      </button>
      <!-- En negro, como el principal del Gateway: el primario global todavía es cian. -->
      <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90"
              *ngIf="puede('create')" (click)="nuevo()">
        <i class="fas fa-plus" aria-hidden="true"></i>Nueva solicitud de alta
      </button>
    </div>
  </div>

  <!-- ══ LAS CUATRO TARJETAS ══════════════════════════════════════════════════
       🔴 2026-09-24, aprobado por Juan: la gramática del Integration Gateway. Una
       fila de cifras arriba; la que pide atención lleva el número y el borde en
       ámbar. Y a diferencia de las cinco que se quitaron el 20-sep (dos filas,
       ~600 px, que sólo mostraban), éstas FILTRAN: reemplazan a la cinta y a los
       tres chips de «Qué le falta», así que cada número aparece una sola vez y
       se puede tocar. Tocar la activa otra vez quita el filtro.
       📍 Son las `.kb-stat` de la casa, no una pieza nueva. La atención va como en
       el Gateway —borde y número ámbar sobre blanco—, no con el relleno de
       `.kb-stat-alerta`; la tarjeta que filtra lleva el anillo (`ring-2`). -->
  <div class="kb-stat-grid" *ngIf="!loading">
    <button type="button" class="kb-stat flex w-full flex-col items-start justify-start text-left ring-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/60" (click)="verTodos()"
            [class.ring-2]="filtros.pendiente === 'todos'"
            [attr.aria-pressed]="filtros.pendiente === 'todos'">
      <span class="kb-stat-label block">Comercios</span>
      <span class="kb-stat-valor block">{{ comercios.length }}</span>
      <span class="kb-stat-pie block">{{ metricas.activos }} con el acuerdo activo</span>
    </button>

    <button type="button" class="kb-stat flex w-full flex-col items-start justify-start text-left ring-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/60" (click)="alternarPendiente('sinHabilitar')"
            [class.border-amber-300]="sinHabilitar > 0"
            [class.ring-2]="filtros.pendiente === 'sinHabilitar'"
            [attr.aria-pressed]="filtros.pendiente === 'sinHabilitar'">
      <span class="kb-stat-label block">No pueden vender</span>
      <span class="kb-stat-valor block" [ngClass]="{ '!text-amber-600 dark:!text-amber-400': sinHabilitar > 0 }">{{ sinHabilitar }}</span>
      <span class="kb-stat-pie block">falta aprobar la ficha, no tiene tiendas o el acuerdo no está activo</span>
    </button>

    <button type="button" class="kb-stat flex w-full flex-col items-start justify-start text-left ring-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/60" (click)="alternarPendiente('sinComision')" *ngIf="verComision"
            [class.border-amber-300]="conSinComision > 0"
            [class.ring-2]="filtros.pendiente === 'sinComision'"
            [attr.aria-pressed]="filtros.pendiente === 'sinComision'">
      <span class="kb-stat-label block">Sin comisión</span>
      <span class="kb-stat-valor block" [ngClass]="{ '!text-amber-600 dark:!text-amber-400': conSinComision > 0 }">{{ conSinComision }}</span>
      <span class="kb-stat-pie block">sin comisión no se le puede facturar</span>
    </button>

    <button type="button" class="kb-stat flex w-full flex-col items-start justify-start text-left ring-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/60" (click)="alternarPendiente('sinCuenta')" *ngIf="verCuenta"
            [class.border-amber-300]="conSinCuenta > 0"
            [class.ring-2]="filtros.pendiente === 'sinCuenta'"
            [attr.aria-pressed]="filtros.pendiente === 'sinCuenta'">
      <span class="kb-stat-label block">Sin cuenta</span>
      <span class="kb-stat-valor block" [ngClass]="{ '!text-amber-600 dark:!text-amber-400': conSinCuenta > 0 }">{{ conSinCuenta }}</span>
      <span class="kb-stat-pie block">sin cuenta bancaria no se le puede liquidar</span>
    </button>
  </div>

  <!-- ══ Filtros ═══════════════════════════════════════════════════════════
       🔴 ESTABA SUELTA SOBRE EL FONDO GRIS. Corregido el 2026-09-21.

       La barra usaba `.kb-toolbar` con el borde y el relleno anulados
       (`border-b-0 px-0 py-0`), o sea: un componente al que se le apagó todo
       lo que lo hacía ser un componente. El resultado era un buscador, un
       desplegable y tres chips flotando sobre el gris de la página, pegados
       a la tabla y sin nada que dijera que son un grupo.

       Así lo hace HZ Notificaciones (`contactos/page.tsx`): los filtros son
       su propia tarjeta blanca, y cada control lleva ARRIBA su etiqueta en
       `text-xs text-muted-foreground`. La etiqueta importa: sin ella, «Todos
       los estados» y los tres chips no dicen por qué criterio filtran — hay
       que apretarlos para averiguarlo.
       ═══════════════════════════════════════════════════════════════════════ -->
  <section class="kb-tarjeta">
    <div class="flex flex-col gap-4 px-6 sm:flex-row sm:flex-wrap sm:items-end">

      <div class="min-w-0 flex-1 space-y-1.5">
        <label class="kb-campo-et" for="buscarComercio">Buscar un comercio</label>
        <div class="kb-buscador">
          <i class="fas fa-search kb-buscador-icono" aria-hidden="true"></i>
          <input id="buscarComercio" type="text" class="kb-input kb-input-icono w-full"
                 placeholder="Código, nombre, razón social o RIF"
                 [(ngModel)]="filtros.busqueda" (ngModelChange)="aplicarFiltros()">
        </div>
      </div>

      <div class="space-y-1.5">
        <label class="kb-campo-et" for="estadoComercio">Estado del acuerdo</label>
        <div class="kb-select-envoltorio w-full sm:w-44">
          <select id="estadoComercio" class="kb-select"
                  [(ngModel)]="filtros.estado" (ngModelChange)="aplicarFiltros()">
            <option value="todos">Todos los estados</option>
            <option value="ACTIVE">Activos</option>
            <option value="SUSPENDED">Suspendidos</option>
            <option value="TERMINATED">Terminados</option>
          </select>
          <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
        </div>
      </div>

      <!-- Sólo si hay proveedores de servicio: sin ellos la pantalla queda como siempre. -->
      <div class="space-y-1.5" *ngIf="hayProveedores">
        <span class="kb-campo-et">Tipo</span>
        <div class="kb-tabs-list" role="group" aria-label="Tipo de comercio">
          <button type="button" class="kb-pestana" [class.kb-pestana-activa]="filtros.tipo === 'todos'"
                  (click)="filtros.tipo = 'todos'; aplicarFiltros()">Todos</button>
          <button type="button" class="kb-pestana" [class.kb-pestana-activa]="filtros.tipo === 'comercios'"
                  (click)="filtros.tipo = 'comercios'; aplicarFiltros()">Comercios</button>
          <button type="button" class="kb-pestana" [class.kb-pestana-activa]="filtros.tipo === 'proveedores'"
                  (click)="filtros.tipo = 'proveedores'; aplicarFiltros()">Proveedores</button>
        </div>
      </div>

      <button type="button" class="kb-btn kb-btn-ghost" *ngIf="hayFiltros" (click)="limpiarFiltros()">
        <i class="fas fa-times !text-foreground" aria-hidden="true"></i>Limpiar filtros
      </button>
    </div>
  </section>

  <!-- ══ La lista ══════════════════════════════════════════════════════════
       🔴 LA TABLA ESTABA DESNUDA SOBRE LA PÁGINA. Corregido el 2026-09-21.

       El comentario de arriba dice «la tabla va a la vista», y era la
       corrección correcta de un exceso anterior: la tabla estaba metida en una
       `.kb-card` CON banda de cabecera, título repetido y subtítulo que
       explicaba el hover. Pero se pasó de largo: quitarle la tarjeta la dejó
       flotando sobre el gris, con las filas hundidas y el conteo colgando al
       costado de los filtros.

       La referencia hace la tercera cosa, que es la que faltaba: la lista vive
       en su tarjeta blanca, la cabecera NO repite el nombre de la pantalla —
       dice CUÁNTAS FILAS hay y por qué orden vienen—, y la tabla va adentro
       con su propio borde (`overflow-x-auto rounded-md border` en
       `contactos/page.tsx`).

       Y ahí se resuelve lo que estaba suelto: el conteo «2 de 2 comercio(s)»
       era un renglón al costado de los filtros que nadie miraba. Como título
       de la tarjeta que contiene las filas, es lo primero que se lee.
       ═══════════════════════════════════════════════════════════════════════ -->
  <section class="kb-tarjeta">
    <div class="kb-tarjeta-cab">
      <div class="space-y-1">
        <h2 class="text-base font-semibold leading-none">
          <ng-container *ngIf="loading">Cargando…</ng-container>
          <ng-container *ngIf="!loading">
            <span class="tabular-nums">{{ filtrados.length }}</span><span *ngIf="hayFiltros">
              de <span class="tabular-nums">{{ comercios.length }}</span></span>
            {{ (hayFiltros ? comercios.length : filtrados.length) === 1 ? 'comercio' : 'comercios' }}
          </ng-container>
        </h2>
        <p class="text-sm text-muted-foreground">
          La fila entera abre la ficha. Los encabezados subrayados ordenan la lista.
        </p>
      </div>
    </div>

    <div class="kb-tarjeta-cuerpo">
  <div class="kb-tabla-plana">
    <table class="kb-table">
      <thead class="kb-thead">
        <tr>
          <th class="kb-th kb-th-orden" (click)="ordenar('code')">
            Código <i class="fas kb-icono-fila" *ngIf="orden.campo === 'code'"
                      [ngClass]="iconoOrden('code')" aria-hidden="true"></i>
          </th>
          <th class="kb-th kb-th-orden" (click)="ordenar('name')">
            Comercio <i class="fas kb-icono-fila" *ngIf="orden.campo === 'name'"
                        [ngClass]="iconoOrden('name')" aria-hidden="true"></i>
          </th>
          <th class="kb-th">RIF</th>
          <th class="kb-th kb-th-orden" (click)="ordenar('venta')">
            Estado de venta <i class="fas kb-icono-fila" *ngIf="orden.campo === 'venta'"
                               [ngClass]="iconoOrden('venta')" aria-hidden="true"></i>
          </th>
          <th class="kb-th kb-th-num kb-th-orden" (click)="ordenar('tiendas')">
            Tiendas <i class="fas kb-icono-fila" *ngIf="orden.campo === 'tiendas'"
                       [ngClass]="iconoOrden('tiendas')" aria-hidden="true"></i>
          </th>
          <th class="kb-th kb-th-num kb-th-orden" *ngIf="verComision" (click)="ordenar('comision')">
            Comisión <i class="fas kb-icono-fila" *ngIf="orden.campo === 'comision'"
                        [ngClass]="iconoOrden('comision')" aria-hidden="true"></i>
          </th>
          <th class="kb-th" *ngIf="verComision">Base de cálculo</th>
          <th class="kb-th kb-th-acciones">Acciones</th>
        </tr>
      </thead>

      <tbody>
        <!-- Cargando: el esqueleto conserva la forma de la tabla -->
        <tr class="kb-tr" *ngIf="loading">
          <td class="kb-td" [attr.colspan]="columnasVisibles">
            <div class="space-y-3 py-2">
              <div class="kb-skeleton h-4 w-full" *ngFor="let s of [1,2,3,4,5]"></div>
            </div>
          </td>
        </tr>

        <!-- Vacío: no es lo mismo "no hay comercios" que "el filtro no encontró nada" -->
        <tr *ngIf="!loading && !filtrados.length">
          <td [attr.colspan]="columnasVisibles">
            <div class="kb-empty">
              <span class="kb-empty-icono">
                <i class="fas" [ngClass]="hayFiltros ? 'fa-filter' : 'fa-handshake'" aria-hidden="true"></i>
              </span>
              <p class="kb-empty-titulo">
                {{ hayFiltros ? 'Ningún comercio coincide con la búsqueda' : 'Todavía no hay comercios' }}
              </p>
              <p class="kb-empty-texto">
                {{ hayFiltros
                   ? 'Prueba con otro texto, cambia el estado o quita los filtros de pendientes.'
                   : 'El primer comercio es MundoTotal, que pasa a ser uno más de la red.' }}
              </p>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="hayFiltros"
                      (click)="limpiarFiltros()">Limpiar filtros</button>
              <button type="button" class="kb-btn kb-btn-primary" *ngIf="!hayFiltros && puede('create')"
                      (click)="nuevo()"><i class="fas fa-plus" aria-hidden="true"></i>Nueva solicitud de alta</button>
            </div>
          </td>
        </tr>

        <!-- Las filas -->
        <tr class="kb-tr kb-tr-clic last:border-b-0" *ngFor="let m of paginados"
            [ngClass]="{'kb-tr-atenuada': m.state === 'TERMINATED'}"
            (click)="abrirDetalle(m)">

          <td class="kb-td kb-td-mono tabular-nums">{{ m.code }}</td>

          <td class="kb-td">
            <!-- La estampa del comercio (ESC-05) a la izquierda; nombre y razón social alineados a su lado -->
            <div class="flex items-center gap-3">
            <app-estampa-comercio [codigo]="m.code" [tam]="32"></app-estampa-comercio>
            <div class="min-w-0">
            <div class="flex items-center gap-2">
              <!-- 2026-09-24: el nombre es el ENLACE a la ficha. Al quitar el ojo, la fila
                   sólo se abría con el mouse; así se llega con Tab y se abre con Enter. -->
              <a class="kb-td-titulo rounded-sm underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/60"
                 [routerLink]="['/console/merchants', m.code]" (click)="$event.stopPropagation()">{{ m.name }}</a>
              <span class="kb-badge" *ngIf="esProveedor(m)" style="background:#ede9fe;color:#5b21b6">Proveedor</span>
              <!-- El pendiente vive junto al dato que falta, no en una columna aparte -->
              <span class="kb-td-alerta" *ngIf="verCuenta && sinCuenta(m)"
                    title="Sin cuenta bancaria: no se le puede liquidar">
                <i class="fas fa-university text-xs" aria-hidden="true"></i>
              </span>
            </div>
            <p class="kb-td-sub" *ngIf="m.legal_name">{{ m.legal_name }}</p>
            <p class="kb-td-sub" *ngIf="!m.legal_name">Sin razón social registrada</p>
            </div>
            </div>
          </td>

          <td class="kb-td kb-td-mono tabular-nums">
            <span *ngIf="m.tax_id">{{ m.tax_id }}</span>
            <span class="italic" *ngIf="!m.tax_id">Sin registrar</span>
          </td>

          <!-- Una sola insignia: la misma que la ficha. El motivo de la suspensión
               o del cierre sigue a mano en el `title`. -->
          <td class="kb-td">
            <span class="kb-badge whitespace-nowrap" [ngClass]="estadoVenta(m).clase"
                  [title]="m.state_reason || estadoVenta(m).texto">
              <i class="fas" [ngClass]="estadoVenta(m).icono" aria-hidden="true"></i>
              {{ estadoVenta(m).texto }}
            </span>
          </td>

          <td class="kb-td kb-td-num">
            <span *ngIf="m.shops_count">{{ m.shops_count }}</span>
            <!-- El cero se muestra: esconderlo borra la diferencia entre «no
                 tiene tiendas» y «no se sabe». -->
            <span class="text-muted-foreground" *ngIf="!m.shops_count">0</span>
          </td>

          <td class="kb-td kb-td-num" *ngIf="verComision">
            <span class="text-muted-foreground" *ngIf="esProveedor(m)">A mano</span>
            <span class="font-medium" *ngIf="!esProveedor(m) && !sinComision(m)">{{ comision(m) }}</span>
            <!-- El plazo va pegado a la comisión: la misma comisión vale distinto
                 según a cuántos días cobra el comercio. -->
            <span class="block text-xs text-muted-foreground tabular-nums" *ngIf="!esProveedor(m) && !sinComision(m)">a {{ plazoCobro(m) }}</span>
            <span class="kb-td-alerta inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium"
                  *ngIf="sinComision(m)" title="Sin comisión no se le puede facturar">
              <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>Sin comisión
            </span>
          </td>

          <!-- Un porcentaje sin base no significa nada: van pegadas -->
          <td class="kb-td" *ngIf="verComision">
            <span class="kb-badge kb-badge-contorno" *ngIf="!esProveedor(m) && !sinComision(m)">{{ baseComision(m) }}</span>
            <span class="text-xs text-muted-foreground" *ngIf="esProveedor(m) || sinComision(m)">—</span>
          </td>

          <td class="kb-td-acciones" (click)="$event.stopPropagation()">
            <div class="kb-acciones-grupo">
              <!-- 2026-09-24: el ojo y el lápiz se fueron (aprobado por Juan). La fila
                   entera ya abre la ficha, y editar se hace desde ahí con
                   «Editar la ficha». Quedan las acciones que la fila no hace. -->
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" title="Suspender el comercio"
                      aria-label="Suspender el comercio"
                      *ngIf="puede('suspend') && m.state === 'ACTIVE'" (click)="cambiarEstado(m,'SUSPENDED')">
                <i class="fas fa-pause-circle" aria-hidden="true"></i></button>
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" title="Reactivar el comercio"
                      aria-label="Reactivar el comercio"
                      *ngIf="puede('suspend') && m.state !== 'ACTIVE'" (click)="cambiarEstado(m,'ACTIVE')">
                <i class="fas fa-play-circle" aria-hidden="true"></i></button>
              <!-- 🔴 2026-09-25: sólo cuando el núcleo lo va a aceptar. Con tiendas (o ventas) responde
                   409 «termínalo en vez de eliminarlo»: a MundoTotal, con 90 tiendas, el botón le
                   mostraba siempre un error. Un comercio con historia se termina, no se borra. -->
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon text-destructive"
                      title="Eliminar el comercio" aria-label="Eliminar el comercio"
                      *ngIf="puede('delete') && !m.shops_count" (click)="eliminar(m)">
                <i class="fas fa-trash-alt" aria-hidden="true"></i></button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ══ Paginación — dentro del cuerpo, separada por el `space-y-5` ══════════ -->
  <div class="kb-pager border-t-0 px-0 py-0" *ngIf="!loading && filtrados.length > porPagina">
    <p class="kb-toolbar-conteo">
      Mostrando {{ desde }}–{{ hasta }} de {{ filtrados.length }}
    </p>
    <div class="flex items-center gap-2">
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
              [disabled]="pagina === 1" (click)="irAPagina(pagina - 1)">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>Anterior
      </button>
      <span class="text-sm tabular-nums text-muted-foreground">{{ pagina }} / {{ totalPaginas }}</span>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
              [disabled]="pagina === totalPaginas" (click)="irAPagina(pagina + 1)">
        Siguiente<i class="fas fa-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>
    </div>
  </section>
</div>
